import { useUserNotifsRetrieve } from "../api-client/user-notifs/user-notifs";
import { REFRESH_INTERVAL_MS } from "../utils/constants";

export const useNotifs = () => {
  return useUserNotifsRetrieve({
    query: {
      refetchInterval: REFRESH_INTERVAL_MS || false,
      staleTime: Infinity,
    },
  });
};
